import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPunchingSm = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "punching-sm" }), /* @__PURE__ */ _jsxs("g", {
		id: "Layer_2",
		"data-name": "Layer 2",
		children: [
			/* @__PURE__ */ _jsx("path", {
				className: "icon-white",
				d: "M91.61,57.63a1,1,0,0,0,0-.17h0a.47.47,0,0,0-.06-.15s0,0,0,0l-.08-.1,0,0a.53.53,0,0,0-.14-.11l-41-23.68a.7.7,0,0,0-.71,0L8.75,56.89a.5.5,0,0,0-.14.1l0,0-.08.1,0,0a.47.47,0,0,0-.06.15h0a.88.88,0,0,0,0,.16v4.29a.71.71,0,0,0,.36.61l7.06,4.08,6.67,11.79a.65.65,0,0,0,.26.26l12,6.91a.69.69,0,0,0,.72,0l6.4-3.93,7.94,4.59a.77.77,0,0,0,.36.09.73.73,0,0,0,.35-.09L91.25,62.53a.72.72,0,0,0,.36-.62V57.63Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "M92.63,57.55a.8.8,0,0,0,0-.23l0,0a.89.89,0,0,0-.1-.23l0-.06a1,1,0,0,0-.14-.17l0-.05a1.74,1.74,0,0,0-.22-.18l-41.57-24a1.2,1.2,0,0,0-1.2,0L8,56.43l-.23.18-.05,0a1.18,1.18,0,0,0-.13.18l0,.06a.85.85,0,0,0-.09.22v0a.67.67,0,0,0,0,.24v4.39a1.2,1.2,0,0,0,.6,1L15,66.9,21.7,78.73a1.19,1.19,0,0,0,.44.45l12.12,7a1.2,1.2,0,0,0,1.23,0l6.24-3.83,7.8,4.5a1.21,1.21,0,0,0,1.2,0L92,63a1.2,1.2,0,0,0,.6-1V57.55ZM92,57.14ZM34.18,81.81a1.19,1.19,0,0,0,1.21,0L41.72,78l7.21,4.16v1.55l-6.62-3.82a1.23,1.23,0,0,0-1.23,0l-6.23,3.83L23.63,77.26,16.94,65.44A1.12,1.12,0,0,0,16.5,65L9.76,61.1V59.55l6.18,3.56L22.57,74.9l0,0v0h0a.28.28,0,0,0,.07.09.94.94,0,0,0,.09.12.79.79,0,0,0,.15.12Zm6.92-6.23-6.34,3.79L26,74.32l1.53-.89a1.2,1.2,0,0,0,.55-.73,1.16,1.16,0,0,0-.12-.91,1.2,1.2,0,0,0-.73-.55,1.16,1.16,0,0,0-.91.12l-2.27,1.32-6.21-11a1.19,1.19,0,0,0-.44-.45L11,57.47,49.87,35,89,57.62,50.13,80.09l-7.82-4.52a1.15,1.15,0,0,0-.6-.16A1.22,1.22,0,0,0,41.1,75.58ZM90.24,59.7v1.55L51.33,83.71V82.16Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "M43.54,63.94a1.25,1.25,0,0,0,.6-.16l1.51-.88a7.82,7.82,0,0,1,1.66-.7,1.2,1.2,0,1,0-.68-2.3,10.5,10.5,0,0,0-2.18.92l-1.52.88a1.2,1.2,0,0,0,.61,2.24Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "M50.75,61.74a11.33,11.33,0,0,1,3.41.56A1.2,1.2,0,1,0,54.92,60a13.88,13.88,0,0,0-4.15-.68,1.2,1.2,0,0,0-.87,2A1.2,1.2,0,0,0,50.75,61.74Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "M33.89,67.37a1.16,1.16,0,0,0-.91.13l-3.32,1.93a1.2,1.2,0,0,0,1.21,2.07l3.31-1.93a1.18,1.18,0,0,0,.56-.73,1.21,1.21,0,0,0-.12-.91A1.18,1.18,0,0,0,33.89,67.37Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "M40.52,63.51a1.21,1.21,0,0,0-.91.12L36.3,65.56a1.18,1.18,0,0,0-.56.73A1.2,1.2,0,0,0,36.9,67.8a1.25,1.25,0,0,0,.6-.16l3.32-1.93a1.2,1.2,0,0,0,.56-.73,1.16,1.16,0,0,0-.13-.91A1.18,1.18,0,0,0,40.52,63.51Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M44.08,47.54a1.23,1.23,0,0,0-.57-.73,1.2,1.2,0,0,0-.91-.1,22.36,22.36,0,0,0-3.79,1.42,1.2,1.2,0,0,0,.52,2.28,1.21,1.21,0,0,0,.53-.12A20.21,20.21,0,0,1,43.25,49,1.21,1.21,0,0,0,44.08,47.54Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M36.3,49.93a1.2,1.2,0,0,0-.91.12L32.06,52a1.25,1.25,0,0,0-.56.73,1.21,1.21,0,0,0,.13.91,1.18,1.18,0,0,0,1.64.43l3.32-1.92A1.2,1.2,0,0,0,37,50.49,1.18,1.18,0,0,0,36.3,49.93Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M29.65,53.79a1.16,1.16,0,0,0-.91.12l-3.32,1.93A1.2,1.2,0,0,0,26,58.08a1.25,1.25,0,0,0,.6-.16L30,56a1.19,1.19,0,0,0,.43-1.64A1.2,1.2,0,0,0,29.65,53.79Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M54.19,48.28a26.67,26.67,0,0,1,3.6.71,1.12,1.12,0,0,0,.32,0,1.19,1.19,0,0,0,1-1.79,1.18,1.18,0,0,0-.72-.56,27.47,27.47,0,0,0-3.94-.78,1.2,1.2,0,1,0-.3,2.38Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M46.68,48.3h.16a27.93,27.93,0,0,1,3.67-.24,1.17,1.17,0,0,0,.85-.35,1.19,1.19,0,0,0,.35-.85,1.2,1.2,0,0,0-1.2-1.2,30.82,30.82,0,0,0-4,.26,1.2,1.2,0,0,0,.15,2.39Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M23,57.65a1.18,1.18,0,0,0-.9.12l-3.32,1.94a1.18,1.18,0,0,0-.56.73,1.21,1.21,0,0,0,.12.91,1.23,1.23,0,0,0,1,.59,1.15,1.15,0,0,0,.6-.16l3.32-1.93a1.18,1.18,0,0,0,.56-.73A1.2,1.2,0,0,0,23,57.65Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M46.56,72.4l-1.91,1.11a1.22,1.22,0,0,0-.44,1.65,1.23,1.23,0,0,0,1,.59,1.32,1.32,0,0,0,.61-.16l1.9-1.11a1.2,1.2,0,0,0-1.2-2.08Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M67.36,60.31a1.18,1.18,0,0,0-1.68.19,10.92,10.92,0,0,1-2.58,2.26,1.2,1.2,0,0,0-.53.75,1.17,1.17,0,0,0,.17.91,1.19,1.19,0,0,0,1.65.36A13.18,13.18,0,0,0,67.56,62,1.19,1.19,0,0,0,67.36,60.31Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M68.5,53.51a1.2,1.2,0,0,0-2.13,1.12A5.1,5.1,0,0,1,67,57a3.81,3.81,0,0,1,0,.59A1.2,1.2,0,0,0,68,59h.16a1.19,1.19,0,0,0,1.18-1A6.54,6.54,0,0,0,69.4,57,7.53,7.53,0,0,0,68.5,53.51Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M60.74,64.55a1.17,1.17,0,0,0-.91.13l-3.32,1.93a1.21,1.21,0,0,0-.43,1.64,1.19,1.19,0,0,0,1,.59,1.15,1.15,0,0,0,.6-.16L61,66.75a1.2,1.2,0,0,0,.55-.73,1.16,1.16,0,0,0-.12-.91A1.18,1.18,0,0,0,60.74,64.55Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M53.19,68.54l-3.32,1.93a1.2,1.2,0,0,0,.61,2.24,1.16,1.16,0,0,0,.6-.17l3.32-1.93a1.2,1.2,0,1,0-1.21-2.07Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M65,52.37a1.18,1.18,0,0,0,.93-.45,1.19,1.19,0,0,0-.18-1.68,15.68,15.68,0,0,0-2.09-1.44c-.45-.26-.92-.5-1.41-.73a1.2,1.2,0,0,0-1.6.57,1.21,1.21,0,0,0,.58,1.6c.43.2.84.42,1.23.64a14.24,14.24,0,0,1,1.78,1.22A1.22,1.22,0,0,0,65,52.37Z"
			})
		]
	})]
});
export default SvgPunchingSm;
